export default {
    en: {
        number: 8,
        diagramId: 7,
        answers: 'every gene is present in every cell Each cell type contains',
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'Almost every gene of the genome is present in every cell of the body, though only some are turned on',
                        answer: '<span class="correct-answer-box correct-answer-box_8">Almost <span class="highlight__answer highlight__answer_correct">every gene</span> of the genome <span class="highlight__answer highlight__answer_correct">is present in every cell</span> of the body, though only some are turned on</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'Each cell type thus contains a unique mix of proteins – a subpopulation of all the proteins available to the cell',
                        answer: '<span class="correct-answer-box correct-answer-box_8"><span class="highlight__answer highlight__answer_correct">Each cell type</span> thus <span class="highlight__answer highlight__answer_correct">contains</span> a unique mix of proteins – a subpopulation of all the proteins available to the cell</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)',
                        answer: '<span class="correct-answer-box correct-answer-box_8">The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise8.js